import {combineReducers} from 'redux';

import general from './org-general/reducer';
import suborgs from './suborgs/reducer';
import subscriptions from './org-subscriptions/reducer';
import users from './org-members/reducer';

export default combineReducers({general, users, subscriptions, suborgs});
